import ClientDirectory from '../features/clients/components/ClientDirectory';

export default function Clients() {
  return (
    <div className="mx-auto max-w-6xl">
      <ClientDirectory />
    </div>
  );
}
